import { ref, watch, unref } from 'vue'
import store from '@/store'

export function useEvento(eventoIdRef) {
    const evento = ref(null)
    const loading = ref(false)
    const error = ref(null)

    const getEvento = async(customId = null) => {
        const id = customId ?? unref(eventoIdRef)

        if (!id) return

        loading.value = true
        error.value = null

        try {
            const res = await store.dispatch('BACK_EVENTS_DETALLE', {
                evento_id: id
            })

            evento.value = res.data.data
        } catch (e) {
            console.error('Error cargando evento', e)
            error.value = e
        } finally {
            loading.value = false
        }
    }

    const resetEvento = () => {
        evento.value = null
    }

    if (eventoIdRef) {
        watch(
            () => unref(eventoIdRef),
            newVal => {
                if (newVal) getEvento(newVal)
            },
            { immediate: false }
        )
    }

    return {
        evento,
        loading,
        error,
        getEvento,
        resetEvento
    }
}
